import { api } from './api';

/**
 * Flow telemetry — fire-and-forget milestone reporting for the EnviroLite
 * inspection flow. Powers the pilot "watch" (server-side flow_events table).
 *
 * Every call is best-effort: failures are swallowed and never awaited in a way
 * that could block or break the inspection flow. Telemetry must be invisible.
 */

export type FlowEventName =
  | 'site_opened'
  | 'inspection_started'
  | 'inspection_submitted'
  | 'submit_failed';

type FlowEventOpts = {
  sessionId?: string;
  siteId?: string;
  inspectionId?: string;
  metadata?: Record<string, unknown>;
};

/** A session id for one inspection sitting (groups that session's events). */
export function newFlowSessionId(): string {
  try {
    if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
      return crypto.randomUUID();
    }
  } catch {
    // fall through to the timestamp fallback
  }
  return `s-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

export function trackFlowEvent(
  event: FlowEventName,
  opts: FlowEventOpts = {}
): void {
  // Intentionally not awaited and fully guarded — telemetry can never throw
  // into the caller or delay the flow.
  void api
    .post('/telemetry/events', {
      event,
      session_id: opts.sessionId,
      site_id: opts.siteId,
      inspection_id: opts.inspectionId,
      metadata: opts.metadata ?? {},
    })
    .catch(() => {
      /* swallow — best-effort */
    });
}
